import { getAuth, onAuthStateChanged } from "firebase/auth";
const { API_ROOT_URL } = require("../../../configs/activebuildconfig.json")

/**
 * CONTROLLER - admins
 * FUNCTION - editPuzzleForAdmin
 * VERIFY - admin
 * @param {*} puzzleData The new puzzle data
 * @param {*} callback Callback function
 * @returns The puzzle data
 */

export const editPuzzleForAdmin = async (puzzleData, callback) => {
    const auth = getAuth();
    onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken(false);
        const response = await fetch(`${API_ROOT_URL}/admins/edit_puzzle`, {
            method: "PUT",
            headers: {
                Accept: "application/json",
                "Content-type": "application/json",
            },
            body: JSON.stringify({
                token,
                puzzleData
            }),
        })
        const result = await response.json();
        callback(result)
    })
}